import * as Yup from "yup";

// Yup validation schema
export const createLinkSchemaValidation = Yup.object().shape({
  link: Yup.string().required("Không được để trống"),
});
